import { ExecutionStrategy } from "@/lib/interfaces and Enums/InterfaceExecutionStrategy";
import { create } from "zustand";

export interface IFillToFlash {
  esid: string;
  blockId: number;
  fillId: number | string;
}

type State = {
  tradeData: ExecutionStrategy[];
  eisdsToFlash: string[];
  esidsToExpand: string[];
  fillsToFlash: IFillToFlash[];
  tradeDataHasReturned: boolean;
  tradeDataLoadAttempted: boolean;
};

type Action = {
  // eslint-disable-next-line no-unused-vars
  updateTradeData: (tradeData: State["tradeData"]) => void;
  // eslint-disable-next-line no-unused-vars
  updateESID: (singleTrade: ExecutionStrategy) => void;
  // eslint-disable-next-line no-unused-vars
  updateEisdsToFlash: (esid: string[]) => void;
  // eslint-disable-next-line no-unused-vars
  updateEsidsToExpand: (esid: string) => void;
  // eslint-disable-next-line no-unused-vars
  resetEsidsToExpand: () => void;
  // eslint-disable-next-line no-unused-vars
  setTradeDataHasReturnedTrue: () => void;
  setTradeDataLoadAttemptedTrue: () => void;
  // eslint-disable-next-line no-unused-vars
  updateFillsToFlash: (fills: IFillToFlash[]) => void;
  clearFillsToFlash: () => void;
};

const tradeDataStore = create<State & Action>((set) => ({
  tradeData: [],
  eisdsToFlash: [],
  esidsToExpand: [],
  fillsToFlash: [],
  tradeDataHasReturned: false, // flag to show that the trades summary has returned. - used to render the action summary table.\
  tradeDataLoadAttempted: false, // the summary fetch finished, success or failure - swaps the blotter's loading overlay for "no rows".

  updateTradeData: (incomingData: ExecutionStrategy[]) => {
    set(() => ({
      tradeData: incomingData,
    }));
  },
  updateEisdsToFlash: (incomingEsid: string[]) => {
    set(() => ({
      eisdsToFlash: incomingEsid,
    }));
  },
  updateFillsToFlash: (incomingFills: IFillToFlash[]) => {
    set(() => ({
      fillsToFlash: incomingFills,
    }));
  },
  clearFillsToFlash: () => {
    set(() => ({
      fillsToFlash: [],
    }));
  },
  // esids put here will tell the action summary table to load the esid in an expanded state.
  updateEsidsToExpand: (incomingEsid: string) => {
    set((state) => ({
      esidsToExpand: [...state.esidsToExpand, incomingEsid],
    }));
  },
  // sets the ESID back to []
  resetEsidsToExpand: () => {
    set(() => ({
      esidsToExpand: [],
    }));
  },
  // Currently not getting used anywhere. Link: https://chatgpt.com/share/6060252f-8c0a-48c5-a4c4-21bf2813c4bf - looking at shallow copy and memo.
  updateESID: (singleTrade) => {
    set((state) => ({
      tradeData: state.tradeData.map((trade) =>
        trade.esid === singleTrade.esid
          ? {
              ...trade,
            }
          : trade,
      ),
    }));
  },
  setTradeDataHasReturnedTrue: () => {
    set(() => ({ tradeDataHasReturned: true }));
  },
  setTradeDataLoadAttemptedTrue: () => {
    set(() => ({ tradeDataLoadAttempted: true }));
  },
}));

export default tradeDataStore;
